<template>
  <div class="replay" @click="handleClick">
    <div class="alive_replay_text">重播</div>
    <svg
      class="icon"
      :class="{ rotating }"
      @animationend="rotating = false"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.51615 7.81935L3.68272 3.58589C3.76604 3.33686 4.09935 3.25385 4.266 3.41987L7.34906 6.49121C7.59904 6.74023 7.51572 7.07227 7.26574 7.15528L3.01611 8.31741C2.6828 8.40042 2.43282 8.15139 2.51615 7.81935Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 4.16667C8.5836 4.16667 7.3284 4.67951 6.27892 5.53083C6.06447 5.70479 5.74919 5.69556 5.56077 5.49369L5.10589 5.00631C4.91748 4.80444 4.92746 4.48678 5.13962 4.31003C6.46071 3.20939 8.10701 2.5 10 2.5C14.1269 2.5 17.5 5.8731 17.5 10C17.5 14.1269 14.1269 17.5 10 17.5C6.0411 17.5 2.77588 14.3959 2.51659 10.5001C2.49826 10.2245 2.72386 10 3 10H3.66667C3.94281 10 4.16441 10.2246 4.18808 10.4997C4.44399 13.4749 6.96185 15.8333 10 15.8333C13.2064 15.8333 15.8333 13.2064 15.8333 10C15.8333 6.79357 13.2064 4.16667 10 4.16667Z"
        fill="currentColor"
      />
    </svg>
  </div>
</template>
<script>
export default {
  emits: ['click'],
  props: {
    videoEl: {
      type: HTMLVideoElement,
      default: null,
    },
  },
  data() {
    return {
      preload_: true,
      rotating: false,
    }
  },
  mounted() {},
  methods: {
    handleClick() {
      // retrigger animation even if clicked rapidly
      this.rotating = false
      this.$nextTick(() => {
        this.rotating = true
      })
      this.$emit('click')
    },
  },
}
</script>
<style lang="less" scoped>
.replay {
  display: flex;
  cursor: pointer;
  align-items: center;
  .alive_replay_text {
    width: max-content;
    font-size: clamp(14px, 3vw, 14px);
    margin-right: 5px;
    white-space: nowrap; // 禁止换行
    @media (max-width: 768px) {
      font-size: 14px;
    }
    @media (max-width: 480px) {
      font-size: 14px;
    }
  }
  .icon {
    width: clamp(14px, 3vw, 20px);
    height: clamp(14px, 3vw, 20px);
    transform-origin: center;

    // 移动端媒体查询
    @media (max-width: 768px) {
      width: 16px;
      height: 16px;
    }

    @media (max-width: 480px) {
      width: 16px;
      height: 16px;
    }
  }
  .icon.rotating {
    animation: spin 0.6s linear;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
